<template>
  <VueShowdown
    :markdown="text"
    :options="{
      emoji: true,
      strikethrough: true,
      ghCodeBlocks: true,
      underline: true
    }"
  ></VueShowdown>
</template>

<script>
import { VueShowdown } from 'vue-showdown'
export default {
  components: {
    VueShowdown
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style></style>
